import {systemMessageBar, SystemMessageBar} from "./component/SystemMessagesComponent";
import {systemMessage, SystemMessage} from "./directive/SystemMessageDirective";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.system`;

    return angular.module(moduleName, [])
                  .component(SystemMessageBar, systemMessageBar())
                  .directive(SystemMessage, systemMessage)
                  .name;
}
